import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { PieceTextRenderComponent } from './piece-text-render.component';


export const pieceTextRenderModuleEntryComponents = [
  PieceTextRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: pieceTextRenderModuleEntryComponents
})
export class PieceTextRenderModule {}

export default pieceTextRenderModuleEntryComponents;
